import { Area, Size } from "../../../types";

// Calculate the image area to fit in a given area
export const getImageArea = (imageSize: Size, area: Area): Area => {
  const imageAspectRatio = imageSize.width / imageSize.height;
  const areaAspectRatio = area.width / area.height;

  let imageWidth: number;
  let imageHeight: number;

  if (imageAspectRatio > areaAspectRatio) {
    // Image is wider than clear area - fit to height
    imageHeight = area.height;
    imageWidth = area.height * imageAspectRatio;
  } else {
    // Image is taller than clear area - fit to width
    imageWidth = area.width;
    imageHeight = area.width / imageAspectRatio;
  }

  return {
    x: area.x - (imageWidth - area.width) / 2,
    y: area.y - (imageHeight - area.height) / 2,
    width: imageWidth,
    height: imageHeight,
  };
};
